import { Box, Stack } from "@mui/material";

import Text from "./Text";
import EmptyIcon from "../icons/ui/EmptyIcon";

const EmptyState = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={"100%"}
    >
      <Stack alignItems="center" justifyContent="center">
        <EmptyIcon width={120} height={120} />
        <Text variant="title_medium" color="mono.grey.2">
          No Result Found
        </Text>
      </Stack>
    </Box>
  );
};

export default EmptyState;
